<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->

<div class="search-n-download">
  <div class="lf-search-container">
    <span class="far fa-search cursor-pointer"></span>
    <img
      src="assets/img/svgs/normal_clear_u481.svg"
      class="clear-img"
      (click)="clearSearch()"
      *ngIf="employeeSearch.value !== ''"
    />
    <input
      #employeeSearch
      type="text"
      class="form-control"
      placeholder="Search"
      [(ngModel)]="searchValue"
      (ngModelChange)="searchInputChange($event)"
    />
  </div>
  <div class="lf-btn-download-container">
    <i
      class="fal fa-arrow-to-bottom"
      [placement]="'bottom'"
      tooltipClass="lf-box-tooltip"
      ngbTooltip="Download CSV"
      (click)="exportData()"
    ></i>
  </div>
</div>
<lfx-new-table
  [columns]="columns"
  [data]="(pageData$ | async) || []"
  [version]="2"
  class="mb-4"
  [selectable]="false"
  [emptyDataMessage]="isLoading ? '' : 'No Activites found in this period.'"
></lfx-new-table>
<lfx-ngb-pagination-wrapper
  *ngIf="collectionSize > 0"
  [collectionSize]="collectionSize"
  [page]="page$ | async"
  (pageChange)="onPageChange($event)"
  [pageSize]="pageSize"
></lfx-ngb-pagination-wrapper>
